import {Component, OnInit} from '@angular/core';
import {DialogRef} from "@fundamental-ngx/core/dialog";
import {Utils} from "../../../../../core/helpers/Utils";

@Component({
    selector: 'app-unified-creation-finished-dialog',
    templateUrl: './unified-suite-creation-finished-dialog.component.html',
    styleUrls: ['./unified-suite-creation-finished-dialog.component.scss'],
    standalone: false
})
export class UnifiedSuiteCreationFinishedDialogComponent implements OnInit {
    res: any;
    rootPath: string;
    path: string;
    testResourceGroupPath: string;
    testFolderName: string;
    payload: any;
    stepSetupParameters: any;

    constructor(private _dialogRef: DialogRef) {
    }

    ngOnInit(): void {
        this.res = this._dialogRef.data.res;
        this.payload = this._dialogRef.data.payload;
        this.stepSetupParameters = this._dialogRef.data.step1;
        this.rootPath = this._dialogRef.data.path;
        this.path = `${this.rootPath}/${this.payload.baseFolderName}`;
        this.testFolderName = this.payload.testFolderName;
        this.testResourceGroupPath = `${this.path}/${this.payload.testFolderName}/${this.payload.testResourceGroupName}`;
    }

    protected readonly Utils = Utils;
}
